import React, { Component } from "react";

export default class AfshanRug extends Component {
  render() {
    let display = this.props.show ? "" : "none";
    return (
      <div style={{ display: display }}>
        <div className="main-carpet-afshan">
          <div className="background-carpet">
            <img
              src={
                this.props.background && this.props.background.image
                  ? this.props.background.image
                  : "/static/img/background.png"
			  }
			  onDragStart={(e) => e.preventDefault()}
              alt="Afshan Background"
            />
          </div>
          <div className="margin-carpet">
            <img
              src={
                this.props.border && this.props.border.image
                  ? this.props.border.image
                  : "/static/img/border.png"
			  }
			  onDragStart={(e) => e.preventDefault()}
              alt="Afshan Border"
            />
          </div>
        </div>
      </div>
    );
  }
}
